export default __webpack_public_path__ + "static/media/Identity_Icon.7cd01984.svg";